export default __webpack_public_path__ + "media/assets/images/chrome-5f211a928f8231baf5608d0d46bc1e47.png";